document.addEventListener('turbolinks:load', () => {
    const guestFeedbackScreenPreview = document.getElementById('guestFeedbackScreenPreview')
    const sgScreenGuest = document.getElementById('sgScreenGuest')
    let feedbackStars
    const filledStarSvg = `<svg class="w-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#E4CC37">
                               <path d="M22,9.24l-7.19,-0.62L12,2 9.19,8.63 2,9.24l5.46,4.73L5.82,21 12,17.27 18.18,21l-1.63,-7.03L22,9.24z" id="path_0"/>
                             </svg>`


    if (guestFeedbackScreenPreview !== null && sgScreenGuest !== null) {
        feedbackStars = sgScreenGuest.getElementsByClassName('feedbackStar')
        if (feedbackStars.length > 0){
            for (let star of feedbackStars){
                star.addEventListener('click', () => {rateStar(parseFloat(star.dataset.star_num))})
            }
        }
    }

    function rateStar(starNumber){
        for (let star of feedbackStars){
            if (parseFloat(star.dataset.star_num)<= starNumber){
                star.innerHTML = filledStarSvg
            }
        }
        setTimeout(openHref, 1000)
    }

    function openHref(){
        //All stars have the same href, so it doesn't matter which star is used
        let star = feedbackStars[0]
        window.open(star.dataset.href,"_self")
    }
})